export const STORYBLOK_BMI_CALCULATOR_LIMIT = {
  NORMAL_WEIGHT: 25,
  OVERWEIGHT: 30,
  UNDERWEIGHT: 18.5,
} as const

export type STORYBLOK_BMI_CALCULATOR_LIMIT =
  (typeof STORYBLOK_BMI_CALCULATOR_LIMIT)[keyof typeof STORYBLOK_BMI_CALCULATOR_LIMIT]
